import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from '../../../core/services/toast.service';

@Component({
  selector: 'app-toast',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="toast-container" aria-live="polite" aria-atomic="true">
      @for (toast of toastService.toasts(); track toast.id) {
        <div class="toast toast--{{ toast.type }}" role="alert">
          <span class="toast__message">{{ toast.message }}</span>
          <button
            class="toast__close"
            aria-label="Dismiss notification"
            (click)="toastService.dismiss(toast.id)"
          >
            &times;
          </button>
        </div>
      }
    </div>
  `,
  styles: `
    .toast-container {
      position: fixed;
      top: var(--spacing-4, 16px);
      right: var(--spacing-4, 16px);
      z-index: var(--z-tooltip, 1100);
      display: flex;
      flex-direction: column;
      gap: var(--spacing-2, 8px);
      max-width: 420px;
    }

    .toast {
      display: flex;
      align-items: center;
      gap: var(--spacing-2, 8px);
      padding: var(--spacing-3, 12px) var(--spacing-4, 16px);
      border-radius: var(--radius-md, 8px);
      box-shadow: var(--shadow-lg, 0 4px 12px rgba(0, 0, 0, 0.15));
      color: #fff;
      font-size: 0.875rem;
      line-height: 1.4;
      animation: slideInRight 0.25s ease-out;
    }

    .toast--error {
      background: var(--color-error, #e53935);
    }

    .toast--success {
      background: var(--color-success, #43a047);
    }

    .toast--warning {
      background: var(--color-warning, #fb8c00);
    }

    .toast--info {
      background: var(--color-info, #1e88e5);
    }

    .toast__message {
      flex: 1;
    }

    .toast__close {
      background: none;
      border: none;
      color: inherit;
      font-size: 1.25rem;
      cursor: pointer;
      padding: 0 0 0 var(--spacing-2, 8px);
      opacity: 0.8;
      line-height: 1;
    }

    .toast__close:hover {
      opacity: 1;
    }

    @keyframes slideInRight {
      from {
        transform: translateX(20px);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
  `,
})
export class ToastComponent {
  protected readonly toastService = inject(ToastService);
}
